import { useCallback, useMemo } from "react";
import { v4 as uuid } from "uuid";

import { HowToWearItWidget } from "@is/types";
import { getHTWISortedMedia } from "@is/utils";

type Props = {
  item: HowToWearItWidget;
  index: number;
  onThumbnailClick: (index: number) => void;
};

const useManageHTWIItemThumbnail = ({
  item,
  index,
  onThumbnailClick,
}: Props) => {
  const thumbnailItem = useMemo(() => {
    const thumbnailMedia = getHTWISortedMedia(item.media).splice(0, 4);
    const length = thumbnailMedia.length;

    let smallerThumbnailMedia = [];
    switch (length) {
      case 0:
      case 1:
        smallerThumbnailMedia = [thumbnailMedia];
        break;
      case 2:
        smallerThumbnailMedia = [[thumbnailMedia[0]], [thumbnailMedia[1]]];
        break;
      case 3:
        smallerThumbnailMedia = [[thumbnailMedia[0]], thumbnailMedia.slice(1)];
        break;
      case 4:
        smallerThumbnailMedia = [
          thumbnailMedia.slice(0, 2),
          thumbnailMedia.slice(2),
        ];
        break;
    }
    return {
      id: uuid(),
      ...item,
      thumbnailMedia: smallerThumbnailMedia,
    };
  }, [item]);

  const handleThumbnailClick = useCallback(() => {
    onThumbnailClick(index);
  }, [onThumbnailClick, index]);

  return {
    thumbnailItem,
    handleThumbnailClick,
  };
};

export default useManageHTWIItemThumbnail;
